import { Controller } from "@hotwired/stimulus";

// Handles per-block selection and language-aware download of onboarding templates.
export default class extends Controller {
  static targets = ["block", "selectAll", "count", "downloadButton"];
  static values = { url: String };

  connect() {
    this.update();
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.blockTargets.forEach((cb) => {
      cb.checked = checked;
    });
    this.update();
  }

  toggleBlock() {
    this.update();
  }

  update() {
    const selected = this.selectedKeys();

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked =
        selected.length > 0 && selected.length === this.blockTargets.length;
      this.selectAllTarget.indeterminate =
        selected.length > 0 && selected.length < this.blockTargets.length;
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = selected.length;
    }

    if (this.hasDownloadButtonTarget) {
      this.downloadButtonTarget.disabled = selected.length === 0;
    }
  }

  selectedKeys() {
    return this.blockTargets.filter((cb) => cb.checked).map((cb) => cb.value);
  }

  lang() {
    const checked = this.element.querySelector(
      "input[name='dl-lang']:checked"
    );
    return checked ? checked.value : "all";
  }

  download(event) {
    event.preventDefault();
    const keys = this.selectedKeys();
    if (keys.length === 0) return;

    const params = new URLSearchParams();
    keys.forEach((key) => params.append("keys[]", key));
    params.append("lang", this.lang());
    window.location.href = `${this.urlValue}?${params.toString()}`;
  }
}
